/**
 * @format
 * @description Financial section or leaf page
 */
export default {
  // available-slots-for-tier: {
  //   html: [],
  //   ldbd: [],
  //   boxr: [],
  //   halfpager: [],
  //   flex: [],
  //   flex2: [],
  //   flex3: [],
  // },
  mobile: {
    html: [[1, 1]],
    flex: [
      [300, 250],
      [320, 250]
    ],
    flex2: [
      [300, 250],
      [300, 600],
      [320, 600]
    ]
  },
  portrait: {
    html: [[1, 1]],
    ldbd: [
      [728, 90],
      [768, 250]
    ],
    flex: [[300, 250]]
  },
  landscape: {
    html: [[1, 1]],
    ldbd: [
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 66],
      [970, 250],
      [1024, 250]
    ],
    boxr: [
      [300, 250],
      [300, 600]
    ],
    halfpager: [
      [300, 250],
      [300, 600]
    ]
  },
  desktop: {
    html: [[1, 1]],
    ldbd: [
      [728, 90],
      [960, 90],
      [970, 90],
      [970, 66],
      [970, 250],
      [1000, 250],
      [1800, 250]
    ],
    boxr: [
      [300, 250],
      [300, 600]
    ],
    halfpager: [
      [300, 250],
      [300, 600]
    ]
  }
};
